import { render, staticRenderFns } from "./FieldLink.vue?vue&type=template&id=15870a2e"
import script from "./FieldLink.vue?vue&type=script&lang=js"
export * from "./FieldLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports